import { __decorate } from "tslib";
// @ts-ignore
import DateHandler from "@/classes/dateHandler";
import Modal from "@/components/Modal.vue";
import WhiteBox from "@/components/WhiteBox.vue";
import moment from "moment";
import { Component, Vue } from "vue-property-decorator";
import Datepicker from "vuejs-datepicker";
import ReportCollection from "../classes/ReportCollection";
import CustomField from "./CustomField.vue";
import axios from "axios";
let TimeInputBox = class TimeInputBox extends Vue {
    async initialLoad() {
        this.$data.reports = this.$props.inReports;
        this.$data.today = this.$data.dateHandler.formatDateNoTime(new Date());
        this.$data.yesterday = this.$data.dateHandler.formatDateNoTime(new Date().getTime() - 1000 * 60 * 60 * 24);
        this.$data.closeDate = this.$data.dateHandler.formatDateNoTime(new Date());
        // this.$data.selectedDate = this.$store.getters.getSelectedDate;
        this.$data.dateInfo = this.$store.getters.getDateInfo;
        this.$data.tariffs = this.$store.getters.getGlobalTariffs; // ändra så att denna laddar själv, ofta den som smäller.
        this.loadHolidayData();
        this.$data.employee = this.$store.getters.getLoggedInUser;
        window.eventBus.$on("selectedMonthReportsUpdated", () => {
            const tempReports = new ReportCollection();
            tempReports.importReportObjectsFromJson(this.$store.getters.getSelectedMonthReports); //create a report collection
            if (tempReports !== undefined) {
                this.$data.reports = tempReports;
                this.$data.weekIds = this.$data.reports.getTariffIdsForWeek();
            }
        });
        this.showWarningAboutLocking();
    }
    // function that loads the holidays data object from the store. Loads locally if available API otherwise.
    loadHolidayData() {
        this.$data.holidays = this.$store.getters.getHolidays;
        if (this.$store.getters.getHolidays === null) {
            const currentYear = moment(this.$store.getters.getSelectedDate).format("YYYY");
            this.$store
                .dispatch("loadHolidaysAsync", { year: currentYear })
                .then((holidays) => {
                this.$store.commit("setHolidays", {
                    data: holidays.data,
                    year: currentYear,
                });
                this.$data.holidays = holidays.data;
            })
                .catch((err) => {
                window.errorHandler.logError(err, "TimeInputBoxes.vue - loadHolidayData");
            });
        }
    }
    //checks if the current tariff is part of the checkbox tariffs
    isCheckboxTariff(inputId) {
        const tariff = this.getTariffFromId(inputId);
        if (tariff !== null) {
            if (tariff.fixedHours !== undefined && tariff.fixedHours !== -1) {
                return true;
            }
            else {
                return false;
            }
        }
        else {
            return false;
        }
    }
    showWarningAboutLocking() {
        const endOfMonth = window.dateHandler
            .getEndOfMonth(new Date())
            .format("YYYY-MM-DD");
        const lastDayIsThisWeek = window.dateHandler.currentWeekContainsDate(this.$store.getters.getSelectedDate, endOfMonth);
        const closedDate = window.dateHandler.formatDateNoTime(this.$data.employee.closedReportsDate);
        if (closedDate < endOfMonth && lastDayIsThisWeek) {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "This is the last week of the current month, please remember to lock your reports when you are done, so that we can calulate your hours.",
            });
        }
    }
    isWeekLocked() {
        if (this.$data.employee !== null) {
            const closedDate = window.dateHandler.formatDateNoTime(this.$data.employee.closedReportsDate);
            const selectedDate = window.dateHandler.getSundayFromDate(this.$store.getters.getSelectedDate);
            if (closedDate >= selectedDate) {
                return true;
            }
        }
        return false;
    }
    isLocked(day) {
        if (this.$data.employee !== null) {
            if (window.dateHandler.convertToUTCTime(this.$data.employee.closedReportsDate) >= window.dateHandler.convertToUTCTime(day.date)) {
                return true;
            }
        }
        return false;
    }
    shortDay(day) {
        return moment(day.date).format("dddd").substring(0, 3);
    }
    selectDateFromCalendar(e) {
        this.$store.commit("setSelectedDate", {
            date: window.dateHandler.convertToUTCTime(e),
        });
        this.$data.selectedDate = this.$store.getters.getSelectedDate;
    }
    copyPreviousWeekTariffs() {
        const previousWeek = Number(this.$store.getters.getDateInfo.week) - 1;
        const tariffIds = this.$data.reports.getTariffIdsForWeek(previousWeek);
        const currentWeekIds = this.$data.reports.getTariffIdsForWeek();
        tariffIds.forEach((id) => {
            if (currentWeekIds.indexOf(id) === -1 &&
                this.$data.temporaryTariffs.indexOf(id) === -1) {
                //only add if it doesnt already
                this.$data.temporaryTariffs.push(id);
            }
        });
    }
    // check if the day is a working day or not to set the red color for all non-working days
    isNonWorkingDay(day) {
        const holidayColl = this.$data.holidays;
        let holiday;
        if (holidayColl !== undefined && holidayColl !== null) {
            holiday = holidayColl.getHolidayForDate(day.date);
        }
        if (holiday !== undefined) {
            return true;
        }
        else if (moment(day.date).isoWeekday() === 6 ||
            moment(day.date).isoWeekday() === 7) {
            return true;
        }
        else {
            return false;
        }
    }
    getBackgroundColor(tariffId) {
        return this.$store.getters.getGlobalTariffs.getColor(tariffId);
    }
    addTariffFromModal() {
        this.$data.temporaryTariffs.push(this.$data.addTariff.selectedTariff.id);
        this.$data.modals.addTariff = false;
        this.$data.addTariffStep = 1;
        this.$data.addTariff.selectedCustomer = null;
        this.$data.addTariff.selectedTariff = null;
        //reset the selected tariff
        //this.$data.addTariff = {selectedCustomer: null, selectedTariff: null};
    }
    getTariffIdsForWeek() {
        const ids = this.$data.reports.getTariffIdsForWeek();
        this.$data.temporaryTariffs.forEach((id) => {
            ids.push(id);
        });
        return ids
            .reverse()
            .filter((value, index, self) => {
            return self.indexOf(value) === index;
        })
            .reverse();
    }
    roundNumber(value, step) {
        step || (step = 1.0);
        const inv = 1.0 / step;
        return Math.round(value * inv) / inv;
    }
    checkboxCreateNewReport(event, inDate, tariffIdLocal) {
        const tariff = this.getTariffFromId(tariffIdLocal);
        if (tariff !== null && tariff !== undefined) {
            event.target.value = tariff.fixedHours;
        }
        else {
            event.target.value = 0;
        }
        this.createNewReport(event, inDate, tariffIdLocal);
    }
    createNewReport(event, inDate, tariffIdLocal) {
        if (this.$data.reports.getReportsForTariffDate(inDate, tariffIdLocal).length >
            0) {
            this.$store.dispatch("ToastMessage", {
                type: "error",
                message: "A report already exists on this date",
            });
        }
        let newValue = this.roundNumber(event.target.value, 0.5);
        if (newValue < 0) {
            newValue = 0;
        }
        event.target.value = newValue;
        if (newValue > 12) {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "You just reported more than 12 hours? Good work, but is this correct?",
            });
        }
        if (newValue === 0) {
            this.$store.dispatch("ToastMessage", {
                type: "error",
                message: "Value has to be 0.5 or greater",
            });
        }
        else {
            const start = this.$data.dateHandler.convertToUTCTime(inDate);
            const end = this.$data.dateHandler.addHours(start, newValue);
            const newReportData = {
                from: start,
                to: end,
                tariffId: tariffIdLocal,
                comment: "",
            };
            this.$store
                .dispatch("createTimeReport", newReportData)
                .then((response) => {
                this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate); //triggers the loading of new reports when the data changes
            })
                .catch((err) => {
                window.errorHandler.logError(err, "TimeInputBoxes.vue - CreateNewReport");
            });
        }
    }
    async duplicateTariff(to, from) {
        this.$data.tariffLoading = true;
        this.$data.temporaryTariffs.push(to);
        const reportsToCopy = [...this.$data.reports.getTariffWeek(from)]
            .map((day) => day.reports)
            .flat();
        const modifiedReports = reportsToCopy.map((report) => {
            report.tariffId = to;
            return report;
        });
        try {
            await Promise.all(modifiedReports.map((report) => {
                this.$store.dispatch("createTimeReport", report);
            }));
        }
        catch (err) {
            window.errorHandler.logError(err, "TimeInputBoxes.vue - CreateNewReport");
        }
        finally {
            await new Promise((resolve) => setTimeout(resolve, 1500)); // wait to ensure post has been done
            await this.initialLoad();
            this.$data.tariffLoading = false;
        }
    }
    modifyReportComment(report) {
        this.$store
            .dispatch("modifyTimeReport", report)
            .then((response) => {
            if (response.status === 204) {
                report.inProgress = false;
                //report.lastSaved = this.$data.dateHandler.convertToUTCTime(new Date());
                this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate); //triggers the loading of new reports when the data changes
            }
        })
            .catch((err) => {
            window.errorHandler.logError(err, "TimeInputBoxes.vue - ModifyReportComment");
        });
    }
    modifyExistingReport(event, report) {
        let newValue = this.roundNumber(event.target.value, 0.5);
        if (newValue < 0) {
            newValue = 0;
        }
        report.hours = newValue;
        event.target.value = newValue;
        if (newValue > 12) {
            this.$store.dispatch("ToastMessage", {
                type: "any",
                message: "You just reported more than 12 hours? Good work, but is this correct?",
            });
        }
        if (newValue === 0) {
            this.deleteReport(report);
        }
        else {
            report.to = this.$data.dateHandler.addHours(report.from, newValue);
            report.inProgress = true;
            this.$store
                .dispatch("modifyTimeReport", report)
                .then((response) => {
                if (response.status === 204) {
                    report.inProgress = false;
                    this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate); //triggers the loading of new reports when the data changes
                }
            })
                .catch((err) => {
                window.errorHandler.logError(err, "TimeInputBoxes.vue - modifyExistingReport");
            });
        }
    }
    getTariffFromId(id) {
        if (this.$data.tariffs !== null) {
            return this.$data.tariffs.getTariffFromId(id);
        }
        else {
            return null;
        }
    }
    lockReports() {
        //const newDate = (window as any).dateHandler.getSundayFromDate(this.$store.getters.getSelectedDate);
        this.$store
            .dispatch("lockReportsAsync", { closeDate: this.$data.closeDate })
            .then((result) => {
            this.$store
                .dispatch("validateEmployeeAsync")
                .then(() => {
                this.$data.employee.closedReportsDate = this.$data.closeDate;
                this.isWeekLocked();
                this.$data.modals.lockReports = false;
                this.$store.dispatch("ToastMessage", {
                    type: "any",
                    message: "You have closed all reports on and before " +
                        this.$data.closeDate,
                });
            })
                .catch((err) => {
                window.errorHandler.logError(err, "TimeInputBoxes.vue - lockReports -> validateEmployeeAsync");
            });
        })
            .catch((err) => {
            window.errorHandler.logError(err, "TimeInputBoxes.vue - lockReports");
        });
    }
    unLockReports() {
        const newDate = window.dateHandler.getSundayFromDate(window.dateHandler.subtractWeeks(this.$store.getters.getSelectedDate, 1));
        this.$store.dispatch("lockReports", { closeDate: newDate });
        this.$data.modals.lockReports = false;
    }
    //Calls the API to remove the report and removes it from the stored reports.
    deleteReport(report) {
        report.inProgress = true;
        this.$store
            .dispatch("removeTimeReport", report)
            .then((response) => {
            if (response.status === 204) {
                report.inProgress = false;
                this.$store.dispatch("loadSelectedMonthReports", this.$store.getters.getSelectedDate); //triggers the loading of new reports when the data changes
            }
        })
            .catch((err) => {
            window.errorHandler.logError(err, "TimeInputBoxes.vue - deleteReport");
        });
    }
    confirmTariffRemoval(tariffId) {
        this.$data.modals.removeTariff = true;
        this.$data.tariffIdToRemove = tariffId;
    }
    //removes an entire row of reports
    removeTariffRow() {
        this.$data.modals.removeTariff = false;
        const tariffId = this.$data.tariffIdToRemove;
        const tempTarr = this.$data.temporaryTariffs.indexOf(tariffId);
        if (tempTarr !== -1) {
            this.$data.temporaryTariffs.splice(tempTarr, 1);
        }
        const tariffReports = this.$data.reports.getTariffWeek(tariffId);
        tariffReports.forEach((day) => {
            day.reports.forEach((report) => {
                if (report.from.split("T")[0] > this.$data.employee.closedReportsDate) {
                    this.deleteReport(report);
                }
            });
        });
    }
    setBackgroundColor(report) {
        return this.$store.getters.getGlobalTariffs.getColor(report.tariffId);
    }
    showCommentsModal(tariffId) {
        const tariff = this.getTariffFromId(tariffId);
        this.$data.selectedTariff = tariff;
        this.$data.modals.showComments = true;
    }
};
TimeInputBox = __decorate([
    Component({
        data() {
            return {
                tariffLoading: false,
                addTariffStep: 1,
                theme: this.$store.getters.getTheme,
                initialized: false,
                dateInfo: null,
                tariffs: null,
                userTariffs: this.$store.getters.getLoggedInUsersTariffs,
                dateHandler: new DateHandler(),
                reports: null,
                modals: {
                    addTariff: false,
                    showComments: false,
                    removeTariff: false,
                    lockReports: false,
                    unlockReports: false,
                },
                addTariff: { selectedCustomer: null, selectedTariff: null },
                temporaryTariffs: [],
                selectedDate: null,
                holidays: null,
                selectedTariff: null,
                tariffIdToRemove: null,
                weekIds: [],
                closeDate: null,
                employee: null,
                today: null,
                yesterday: null,
                showDateCalendar: false,
                debounceFunctions: {},
                temporaryReports: new ReportCollection(),
                tempReportsLoading: false,
            };
        },
        props: {
            inReports: ReportCollection,
        },
        async mounted() {
            await this.initialLoad();
        },
        watch: {
            closeDate() {
                // @ts-ignore
                this.getAndSetTempReportsForLocking();
            },
            lockReportModal() {
                if (this.$data.modals.lockReports) {
                    this.$data.closeDate = moment().format("YYYY-MM-DD");
                    // Any changes made to time reports after initial render
                    // will not be reflected in the modal, so we need to
                    // re-fetch the reports
                    // @ts-ignore
                    this.getAndSetTempReportsForLocking();
                }
            },
        },
        methods: {
            totalHoursForDay(day) {
                try {
                    return day.reports[0].hours;
                }
                catch {
                    return null;
                }
            },
            updateComment(value, report) {
                report.comment = value.trim();
                report.inProgress = true;
                this.modifyReportComment(report);
            },
            async getAndSetTempReportsForLocking() {
                this.$data.tempReportsLoading = true;
                // Start date will always be the first date of a month,
                // but two scenarios can occur:
                //
                // 1. If the last lock date was the last day of a month
                //    the start date will be the first day of the NEXT month
                //
                // 2. If the last lock date was NOT the last day of a month
                //    the start date will be the first day of the SAME month
                const start = moment(this.$data.employee.closedReportsDate)
                    .add(1, "day")
                    .startOf("month")
                    .format("YYYY-MM-DD[T]00:00:00[Z]");
                const end = moment(this.$data.closeDate)
                    .endOf("month")
                    .format("YYYY-MM-DD[T]23:59:59[Z]");
                const params = new URLSearchParams();
                params.append("from", start);
                params.append("to", end);
                const response = await axios.get(`/reports`, { params });
                this.$data.temporaryReports = new ReportCollection();
                this.$data.temporaryReports.importReportObjectsFromJson(response.data);
                this.$data.tempReportsLoading = false;
            },
        },
        computed: {
            // userTariffs() {
            //   try {        
            //     return this.$store.getters.getLoggedInUsersTariffs;
            //   } catch {
            //     return []
            //   }
            // },
            disabledInput() {
                return this.$vuetify.theme.dark ? "disabledDark" : "disabledLight";
            },
            lockReportModal() {
                return this.$data.modals.lockReports;
            },
            monthsLackingHours() {
                if (!this.$data.modals.lockReports) {
                    return [];
                }
                const start = moment(this.$data.employee.closedReportsDate)
                    .add(1, "day")
                    .startOf("month")
                    .format("YYYY-MM-DD");
                const end = this.$data.closeDate;
                const allMonthEndingDates = new Array(12).fill(0).map((_, i) => {
                    const endOfMonth = moment()
                        .month(i)
                        .endOf("month")
                        .format("YYYY-MM-DD");
                    return endOfMonth;
                });
                const activeEndDates = allMonthEndingDates.filter((d) => d >= start && d <= end);
                if (activeEndDates.length === 0) {
                    return [];
                }
                const reports = this.$data.temporaryReports;
                const months = activeEndDates.map((d) => {
                    const periodStart = moment(d).startOf("month").format("YYYY-MM-DD");
                    // const periodEnd = d
                    const holidays = this.$store.getters.getHolidays;
                    const availableHours = reports.calculateAvailableHours(holidays, periodStart);
                    const totalWorked = reports.calculateMonthTime(periodStart);
                    // console.log(totalWorked, availableHours, d);
                    if (totalWorked < availableHours) {
                        // console.log(d);
                        return {
                            month: moment(d).format("MMMM"),
                            totalWorked,
                            availableHours,
                        };
                    }
                    return null;
                });
                return months.filter((m) => m);
            },
            billableReportsWithoutCommentsDates() {
                if (this.$data.temporaryReports === null || !this.$data.employee) {
                    return [];
                }
                const start = this.$data.employee.closedReportsDate;
                const end = this.$data.closeDate;
                const reports = this.$data.temporaryReports.reports.filter((r) => {
                    return r.date >= start && r.date <= end;
                });
                return reports
                    .filter((r) => r.type === "Billable" || r.type === "Stack")
                    .filter((r) => {
                    return r.comment === null || r.comment === "";
                })
                    .map((r) => r.date);
            },
            duplicateShow() {
                const user = this.$store.getters.getTokenProfile;
                return (user.unique_name === // Axel
                    "axel.forsberg@geshdo.com" ||
                    user.unique_name === // Jesper
                        "jesper.asplund@geshdo.com");
            },
            notUsedTariffs() {
                try {
                    //@ts-ignore
                    return this.userTariffs.tariffs
                        .filter((t) => {
                        return (!this.getTariffIdsForWeek().includes(t.id) &&
                            t.name !== "Semester");
                    })
                        .map((t) => {
                        return {
                            text: `${t.customerName} - ${t.name}`,
                            id: t.id,
                        };
                    })
                        .sort((a, b) => (a.text > b.text ? 1 : -1));
                }
                catch (err) {
                    console.log(err);
                    return [];
                }
            },
            closedReportsDate() {
                try {
                    return this.$data.employee.closedReportsDate;
                }
                catch {
                    return "";
                }
            },
        },
        components: {
            WhiteBox,
            Modal,
            Datepicker,
            CustomField,
        },
    })
], TimeInputBox);
export default TimeInputBox;
